// import $ from 'jquery'

// core
import Imgix from './core/Imgix'
import {ixPolyfill} from './core/Imgix'
import Waypoints from './core/Waypoints'
import LightboxGallery from './core/LightboxGallery'
import ButtonModal from './core/ButtonModal'

// modules
import Accordion from './modules/Accordion'
import ClassTimetable from './modules/ClassTimetable'
import Grid from './modules/Grid'
import Slider from './modules/Slider'
import Navigation from './modules/Navigation'
import GravityFormsValidator from './modules/GravityFormsValidator'
import FilterableAccordion from './modules/FilterableAccordion'
// import scrollDirection from './modules/ScrollDirection'

// core
const imgixInstance = new Imgix();
new Waypoints();
new ButtonModal();

// imgix polyfill for core
ixPolyfill();

// modules
new Navigation();
// new scrollDirection();

document.querySelectorAll("[data-module=accordion]").forEach((el) => {
    new Accordion(el)
})
document.querySelectorAll("[data-module=grid]").forEach((el) => {
    new Grid(el)
})
document.querySelectorAll("[data-module=slider]").forEach((el) => {
    new Slider(el)
})
document.querySelectorAll("[data-module=lightbox-gallery],[data-module=grid]").forEach((el) => {
    new LightboxGallery(el)
})
document.querySelectorAll('.o-form').forEach(element => {
    new GravityFormsValidator({el: element});
});

document.querySelectorAll('.c-class-timetable').forEach(element => {
    new ClassTimetable(element);
});

document.querySelectorAll('.c-filterable-accordion').forEach(element => {
    new FilterableAccordion(element);
});

let lastScrollY = 0;
const scrollThreshold = 5;

window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY;

    // Check if we scrolled down past the threshold
    if (currentScrollY > scrollThreshold && currentScrollY > lastScrollY) {
        document.body.classList.add("page-is-scrolled");
    }
    // Check if we scrolled up by at least 50px and are not at the top
    else if (lastScrollY - currentScrollY >= scrollThreshold || currentScrollY <= scrollThreshold) {
        document.body.classList.remove("page-is-scrolled");
    }

    lastScrollY = currentScrollY;
});


window.addEventListener('load', () => {
    imgix.fluid = () => {
        imgixInstance.process(document.body)
    }
})

// document.addEventListener('DOMContentLoaded', () => {
//     const golfLinks = document.querySelectorAll('.golf-link');

//     golfLinks.forEach(link => {
//         link.addEventListener('click', (event) => {
//             event.preventDefault(); // Prevent default navigation
//             const targetURL = link.href;

//             // Get the current and target navigation entries
//             const fromNavigationEntry = {
//                 url: window.location.href,
//             };
//             const toNavigationEntry = {
//                 url: targetURL,
//             };

//             // Determine the transition type
//             const transitionType = determineTransitionType(fromNavigationEntry, toNavigationEntry);

//             // Start the view transition if supported
//             if (document.startViewTransition) {
//                 document.startViewTransition(() => {
//                     document.documentElement.classList.remove('view-transition-forwards', 'view-transition-backwards', 'view-transition-reload');
//                     document.documentElement.classList.add(`view-transition-${transitionType}`);

//                     // Allow time for transition before navigating
//                     setTimeout(() => {
//                         window.location.href = targetURL;
//                     }, 500); // Adjust timing as needed
//                 });
//             } else {
//                 // Fallback for unsupported browsers
//                 window.location.href = targetURL;
//             }
//         });
//     });
// });

// // Function to determine the transition type
// const determineTransitionType = (fromNavigationEntry, toNavigationEntry) => {
//     const currentURL = new URL(fromNavigationEntry.url);
//     const destinationURL = new URL(toNavigationEntry.url);

//     if (currentURL.pathname === destinationURL.pathname) {
//         return 'reload'; // Same page reload
//     } else {
//         const currentPageIndex = extractPageIndexFromPath(currentURL.pathname);
//         const destinationPageIndex = extractPageIndexFromPath(destinationURL.pathname);

//         if (currentPageIndex === -1 || destinationPageIndex === -1) {
//             return 'forwards'; // Default to forwards if index extraction fails
//         }

//         return currentPageIndex > destinationPageIndex ? 'backwards' : 'forwards';
//     }
// };

// // Function to extract page index from URL pathname
// const extractPageIndexFromPath = (pathname) => {
//     const match = pathname.match(/hole-(\d+)/);
//     return match ? parseInt(match[1], 10) : -1;
// };
